<template>
  <div class="store-selector-container">
    <div class="store-label" v-if="label">{{ label }}</div>
    <div class="flex flex-between mb10" v-if="!readonly">
      <div class="flex flex-center">
        <el-button
          v-if="joinTypeFilter === 'join' || joinTypeFilter === 'self'"
          type="primary"
          plain
          size="small"
          @click="showStoreDialog = true"
        >
          + 添加商店
        </el-button>
         <el-select
          v-if="showStoreType"
          v-model="joinTypeFilter"
          placeholder="商店类型"
          size="small"
          style="width: 120px"
          class="ml10 mlr0"
          @change="handleTypeChange"
        >
          <el-option label="全部商店" value="all"></el-option>
          <el-option label="加盟店" value="join"></el-option>
          <el-option label="直营店" value="self"></el-option>
        </el-select>
        <el-input
          v-model="searchName"
          placeholder="请输入商店名称搜索"
          clearable
          size="small"
          style="width: 200px"
          class="ml10"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div>
        <div @click="handleExportTemplate" class="delete pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          下载模板
        </div>
        <div class="delete mr20 pointer open-file" style="margin-left:20px;">
          <span class="delete-icon hmicon icon-daoru"></span>
          导入
          <input
            type="file"
            @change="handleImportFile"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </div>
    </div>

    <!-- 只读模式下的搜索框 -->
    <div class="flex flex-between mb10" v-if="readonly">
      <div class="flex flex-center">
        <el-input
          v-model="searchName"
          placeholder="请输入商店名称搜索"
          clearable
          size="small"
          style="width: 200px"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select
          v-if="showStoreType"
          v-model="joinTypeFilter"
          disabled
          placeholder="商店类型"
          size="small"
          style="width: 120px"
          class="ml10"
        >
          <el-option label="全部商店" value="all"></el-option>
          <el-option label="加盟店" value="join"></el-option>
          <el-option label="直营店" value="self"></el-option>
        </el-select>
      </div>
    </div>
    <div v-if="!readonly">
      <!-- <el-checkbox
          :value="isAllSelected"
          size="small"
          class="ml10"
          :indeterminate="isIndeterminate"
          @change="handleSelectAllChange"
        >
          {{ isAllSelected ? '取消全选' : '全选商店' }}
        </el-checkbox> -->
    </div>
    <div class="table mb10">
      <el-table
        stripe
        ref="storeTable"
        :data="paginatedStoreList"
        style="width: 100%"
        id="table"
        size="small"
        border
        max-height="400"
      >
        <el-table-column type="index" label="序号"></el-table-column>
         <el-table-column
          v-if="showStoreType"
          header-align="center"
          align="center"
          prop="joinType"
          label="商店类型"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.joinType === 'join' ? '加盟店' : '直营店' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="商店名称"
        ></el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          v-if="!readonly"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip
                class="item"
                content="删除"
                placement="top"
              >
                <div class="pointer mr10" @click="handleDeleteStore(scope.row)">
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination store-pagination">
      <el-pagination
        background
        :total="filteredTotal"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
      ></el-pagination>
    </div>

    <!-- 导入失败弹窗 -->
    <el-dialog
      :visible.sync="errValidImport"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="50%"
    >
      <div slot="title">
        <span class="dialog-title">导入失败</span>
        <span class="ml10" style="color: red; font-size: 14px"
          >商店名称有误、商店不存在都会导致导入失败</span
        >
      </div>
      <div class="mt10" style="font-size: 14px" v-if="errValidImportList.length">
        您有<span style="color: red">{{ errValidImportList.length }}</span
        >条数据导入失败！

      </div>
      <div class="mt10" v-if="successCount > 0">
        您有<span class="success">{{ successCount }}</span
        >条数据导入成功！
      </div>
      <div class="mb20" style="float: right">
         <span class="pointer ml10 no-bg blue" @click="exportFailListData(errValidImportList)">导出失败数据</span>
      </div>
      <div class="mt20">
        <el-table :data="errValidImportList" border class="small-table">
          <el-table-column
            prop="shopName"
            header-align="center"
            align="center"
            label="商店名称"
          ></el-table-column>
           <el-table-column
            prop="shopCode"
            header-align="center"
            align="center"
            label="商店编码"
          ></el-table-column>
          <el-table-column
            prop="restrictionReason"
            header-align="center"
            align="center"
            label="失败原因"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 添加商店弹窗 -->
    <store-dialog
      :visible.sync="showStoreDialog"
      :selected-stores="storeList"
      :all-stores="allStores"
      :store-code="storeCode"
      :store-type-filter="joinTypeFilter"
      @confirm="handleConfirmAddStores"
    />
  </div>
</template>

<script>
import StoreDialog from './StoreDialog.vue';
import * as XLSX from "xlsx/xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  name: 'StoreSelector',
  components: {
    StoreDialog
  },
  props: {
    // 表单项标签
    label: {
      type: String,
      default: '选择商店:'
    },
    // 商店列表（已选中的商店）
    storeList: {
      type: Array,
      default: () => []
    },
    // 是否只读
    readonly: {
      type: Boolean,
      default: false
    },
    // 所有可选商店列表
    allStores: {
      type: Array,
      default: () => []
    },
    // 商店编码（用于判断是否显示商店类型）
    storeCode: {
      type: String,
      default: ''
    },
    // 商店类型筛选（支持v-model）
    storeType: {
      type: String,
      default: 'self'
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showStoreDialog: false,
      searchName: '',
      joinTypeFilter: this.storeType || 'self', // 商店类型筛选，默认为直营店
      errValidImport: false, // 导入失败弹框
      errValidImportList: [], // 失败数据列表
      successCount: 0, // 成功导入数量
      importType: 'store', // 导入类型
      isIndeterminate: false // 半选状态
    };
  },
  computed: {
    // 分页后的商店列表
    paginatedStoreList() {
      // 先根据商店名称和类型过滤
      let filteredList = this.storeList;

      filteredList = this.storeList.filter(item => {
        // 商店名称过滤
        let nameMatch = true;
        if (this.searchName) {
          nameMatch = item.shopName && item.shopName.includes(this.searchName);
        }

        // 商店类型过滤（all时不进行筛选）
        let typeMatch = true;
        if (this.showStoreType && this.joinTypeFilter && this.joinTypeFilter !== 'all') {
          if (this.joinTypeFilter === 'join') {
            typeMatch = item.joinType === 'join';
          } else if (this.joinTypeFilter === 'self') {
            typeMatch = item.joinType !== 'join';
          }
        }

        return nameMatch && typeMatch;
      });

      // 再进行分页
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return filteredList.slice(start, end);
    },
    // 过滤后的总数量
    filteredTotal() {
      return this.storeList.filter(item => {
        // 商店名称过滤
        let nameMatch = true;
        if (this.searchName) {
          nameMatch = item.shopName && item.shopName.includes(this.searchName);
        }

        // 商店类型过滤（all时不进行筛选）
        let typeMatch = true;
        if (this.showStoreType && this.joinTypeFilter && this.joinTypeFilter !== 'all') {
          if (this.joinTypeFilter === 'join') {
            typeMatch = item.joinType === 'join';
          } else if (this.joinTypeFilter === 'self') {
            typeMatch = item.joinType !== 'join';
          }
        }

        return nameMatch && typeMatch;
      }).length;
    },
     // 是否显示商店类型筛选和列
    showStoreType() {
      return this.storeCode === '53010017032439' || this.storeCode === '42010216070190';
    },
    // 是否全选
    isAllSelected: {
      get() {
        if (this.storeList.length === 0 || this.allStores.length === 0) {
          return false;
        }
        // 检查当前 storeList 是否包含了所有 allStores
        const storeCodeSet = new Set(this.storeList.map(s => s.shopCode));
        return this.allStores.every(store => storeCodeSet.has(store.shopCode));
      },
      set(val) {
        // 由 handleSelectAllChange 处理
      }
    }
  },
  watch: {
    // 监听 storeType prop 变化，同步更新内部状态
    storeType: {
      handler(newVal) {
        if (newVal && newVal !== this.joinTypeFilter) {
          this.joinTypeFilter = newVal;
        }
      },
      immediate: true
    },
    // 监听商店列表变化，更新总数
    storeList: {
      handler(newVal) {
        this.total = newVal.length;
        // 如果当前页超出了总页数，重置到第一页
        const totalPages = Math.ceil(this.filteredTotal / this.pageSize);
        if (this.currentPage > totalPages && totalPages > 0) {
          this.currentPage = 1;
        }
        // 更新半选状态
        this.updateIndeterminateState();
      },
      immediate: true
    },
    // 监听 allStores 变化，更新半选状态
    allStores: {
      handler() {
        this.updateIndeterminateState();
      },
      immediate: true
    },
    // 监听搜索关键词变化，重置到第一页
    searchName() {
      this.currentPage = 1;
    }
  },
  methods: {
    // 处理商店类型变化
    handleTypeChange(newVal) {
      this.currentPage = 1;
      // 通知父组件类型变化
      this.$emit('update:storeType', newVal);
      if (newVal === 'all') {
        // 全部商店时自动全选
        this.$emit('add-stores', this.allStores);
      } else {
        // 其他情况清空所有商店
        this.$emit('clear-all-stores');
      }
    },
    // 处理导出模板
    handleExportTemplate() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
         const tHeader = ["商店名称", "商店编码"];
        const data = [];
        exportJsonToExcel(tHeader, data, "商店导入模板");
      });
    },
    // 处理导入文件
    handleImportFile(event) {
      const obj = event.target;
      const that = this;

      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
         wb = XLSX.read(data, {
            type: "binary",
          });
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        let isRequired = true;
        result.forEach(v => {
          if (!v[0] || !v[1] ) {
            isRequired = false;
          }
          formatResult.push({
            shopName:v[0]? (v[0] + "")
                  .replace(/\s*/g, "")
                  .replace("（", "(")
                  .replace("）", ")")
              : "",
            shopCode:v[1] ? (v[1] + "").replace(/\s*/g, "") : ""
          });
        });
        // 前端对比商店数据
        if (formatResult.length > 0) {
          if (!isRequired) {
            that.$message.warning('导入失败，请导入完整商店信息！');
            return;
          }
          that.compareStores(formatResult);
        } else {
          that.$message.warning('请先上传有效的文件');
        }
      };
       reader.readAsBinaryString(f);
      obj.value = "";
    },
    // 前端对比商店数据
    compareStores(importList) {
      const successList = [];
      const failList = [];

      importList.forEach(importStore => {
        // 在allStores中查找匹配的商店
        const matchedStore = this.allStores.find(store => {
          // 根据商店名称匹配
          return store.shopName === importStore.shopName || store.shopCode === importStore.shopCode;
        });

        if (matchedStore) {
          successList.push({
            shopName: matchedStore.shopName,
            shopCode: matchedStore.shopCode,
            delFlag: '1'
          });
        } else {
          failList.push({
            shopName: importStore.shopName,
            shopCode: importStore.shopCode,
            restrictionReason: '商店不存在或者商店错误'
          });
        }
      });

      // 设置成功数量
      this.successCount = successList.length;

      // 处理成功的数据
      if (successList.length > 0) {
        // 触发事件通知父组件添加商店
        this.$emit('add-stores', successList);
      }

      // 处理失败的数据
      if (failList.length > 0) {
        this.errValidImportList = failList;
        this.errValidImport = true;
      } else {
        this.errValidImportList = [];
      }

      // 全部成功的情况
      if (successList.length > 0 && failList.length === 0) {
        this.$message.success(`成功导入 ${successList.length} 家商店`);
      }

      if (successList.length === 0 && failList.length === 0) {
        this.$message.warning('未找到匹配的商店数据');
      }
    },
    // 处理删除商店
    handleDeleteStore(store) {
      this.$emit('delete-store', store);
    },
    // 处理当前页变化
    handleCurrentChange(page) {
      this.currentPage = page;
    },
    // 处理每页条数变化
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
    },
    // 处理确认添加商店
    handleConfirmAddStores(selectedStores) {
      this.$emit('add-stores', selectedStores);
      this.showStoreDialog = false;
    },
    // 导出失败数据
    exportFailListData(list) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商店名称", "商店编码", "失败原因"];
        const data = list.map(item => {
          return [item.shopName, item.shopCode, item.restrictionReason];
        });
        exportJsonToExcel(tHeader, data, "商店导入失败数据");
      });
    },
    // 处理全选/取消全选
    handleSelectAllChange() {
      // 使用计算属性判断当前实际状态，而不是传入的 val
      if (!this.isAllSelected) {
        // 全选：添加所有商店
        this.$emit('add-stores', this.allStores);
      } else {
        // 取消全选：清空所有商店
        this.$emit('clear-all-stores');
      }
    },
    // 更新半选状态
    updateIndeterminateState() {
      if (this.storeList.length === 0 || this.allStores.length === 0) {
        this.isIndeterminate = false;
        return;
      }
      const storeCodeSet = new Set(this.storeList.map(s => s.shopCode));
      const hasSelected = this.allStores.some(store => storeCodeSet.has(store.shopCode));
      const hasUnselected = this.allStores.some(store => !storeCodeSet.has(store.shopCode));
      this.isIndeterminate = hasSelected && hasUnselected;
    }
  }
};
</script>

<style lang="scss" scoped>
.store-selector-container {
  .store-label {
    font-weight: bold;
    margin-bottom: 10px;
  }
}

.hm-pagination {
  font-family: PingFang SC;
}

.store-pagination {
  margin-top: 20px;
}

.pointer {
  cursor: pointer;
}

.primary {
  color: #0B66EA;
}

.mr10 {
  margin-right: 10px;
}

.mr20 {
  margin-right: 20px;
}

.mb10 {
  margin-bottom: 10px;
}

.ml10 {
  margin-left: 10px;
}

.flex {
  display: flex;
}

.flex-between {
  justify-content: space-between;
}

.flex-center {
  align-items: center;
}

.open-file {
  position: relative;
  overflow: hidden;
  display: inline-block;

  input {
    position: absolute;
    left: 0px;
    top: 0px;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}

.delete {
  display: inline-flex;
  align-items: center;
//   color: #0B66EA;
  font-size: 14px;
  cursor: pointer;

  .delete-icon {
    margin-right: 4px;
  }
}
</style>
